__turbopack_context__.v({
  "breadcrumbsWrap": "style-module-scss-module__FFfBOq__breadcrumbsWrap",
  "heroMedia": "style-module-scss-module__FFfBOq__heroMedia",
  "infoWrapper": "style-module-scss-module__FFfBOq__infoWrapper",
  "tagsWrapper": "style-module-scss-module__FFfBOq__tagsWrapper",
  "timeToRead": "style-module-scss-module__FFfBOq__timeToRead",
  "title": "style-module-scss-module__FFfBOq__title",
  "wrapper": "style-module-scss-module__FFfBOq__wrapper",
});
